import {
  propertyManagerRolePermission,
  propertyOwnerRolePermission,
} from '../RMS/utils/permissions';

export const propertiesRolePermissions = [
  'Owner',
  'ManagedOwner',
  'FlipdishStaff',
  ...propertyManagerRolePermission,
  ...propertyOwnerRolePermission,
] as AppState['permissions'];

export const propertiesAuthZPermissions = [
  'ViewProperty',
  'FlipdishStaff',
] as AppState['permissions'];

export const getPropertiesPermissions = (useAuthZPermissions: boolean): AppState['permissions'] =>
  useAuthZPermissions ? propertiesAuthZPermissions : propertiesRolePermissions;

export const propertiesPermissions = propertiesRolePermissions;
